export default "__VITE_ASSET__EWiH1kAw__"